'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Skeleton } from '@eliadmin/core/src/components/ui/skeleton';

export const CompanyCardSmallSkeleton = () => {
  return (
    <div className="group flex h-[362px] w-full flex-col justify-start overflow-hidden rounded-2xl border border-border bg-background shadow-sm">
      <div className="relative h-[168px] min-h-[168px] w-full">
        <Skeleton className="h-full w-full" />
      </div>
      <div className="flex flex-col gap-2 p-4">
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-3 w-1/2" />
        <div className="flex flex-wrap gap-1">
          <Skeleton className="h-5 w-16" />
          <Skeleton className="h-5 w-20" />
        </div>
        <div className="flex flex-wrap gap-1">
          <Skeleton className="h-4 w-12" />
          <Skeleton className="h-4 w-14" />
        </div>
        <Skeleton className="h-3 w-2/3" />
      </div>
    </div>
  );
};
